import(/* webpackMode: "eager" */ "/app/src/app/resources/(with-layout)/security-advisories/layout.tsx");
